export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', name, params);
      if (name === 'report_lead') {
        window.fbq('track', 'Lead', params);
      }
    }
  } catch (e) {
    // tracking must never break the UX
  }
};
